import {useAppSelector} from '../../../../hooks/react-redux'
import type {GlobalSearchKind} from '../Shortcuts.types'

import {useSearchShortcutEffect} from './useSearchShortcutEffect'
import {useSearchShortcutHandler} from './useSearchShortcutHandler'

export const useSearchShortcut = (callbackHandler: () => unknown, kind?: GlobalSearchKind) => {
  useSearchShortcutEffect({
    kind,
  })
  const enabled = useAppSelector(state => {
    if (kind) {
      return state.shortcuts.globalSearch[kind].count > 0
    }
    return false
  })

  useSearchShortcutHandler(enabled, callbackHandler)
}
